export default "__VITE_ASSET__BigYnEo2__"